import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'script-snippet',
  setup(__props) {

const snippet = ref<HTMLElement | null>(null);

const executeScript = () => {
  if (snippet.value) {
    try {
      const script = document.createElement("script");
      script.textContent = snippet.value.innerText;
      document.body.appendChild(script);
      document.body.removeChild(script);
    } catch (error) {
      console.error("Error executing script:", error);
    }
  }
};

watch(snippet, (newSnippet) => {
  if (newSnippet) {
    executeScript();
  }
});

onMounted(() => {
  nextTick(() => {
    executeScript();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "script-snippet",
    ref_key: "snippet",
    ref: snippet
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})